import { useEffect, useRef, useState } from "preact/hooks";

/** 复制成功后亮 1.8 秒；新内容仍可立即复制，失败由调用方给出反馈。 */
export function useCopy({ repeat = false }: { repeat?: boolean } = {}): [
  copied: boolean,
  copy: (text: string) => Promise<boolean>,
] {
  const [copied, setCopied] = useState(false);
  const generation = useRef(0);
  const lastText = useRef<string>();
  useEffect(
    () => () => {
      generation.current += 1;
    },
    [],
  );
  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => {
      setCopied(false);
    }, 1800);
    return () => {
      clearTimeout(timer);
    };
  }, [copied]);
  const copy = async (text: string) => {
    if (!repeat && copied && lastText.current === text) return true;
    lastText.current = text;
    const attempt = ++generation.current;
    setCopied(false);
    try {
      await navigator.clipboard.writeText(text);
      if (generation.current !== attempt) return false;
      setCopied(true);
      return true;
    } catch {
      return false;
    }
  };
  return [copied, copy];
}
